function joinNames(names: string[]): string {
  if (names.length <= 3) {
    if (names.length <= 1) return names[0] ?? "";
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    return `${names[0]}, ${names[1]}, and ${names[2]}`;
  }
  const extra = names.length - 3;
  return `${names[0]}, ${names[1]}, ${names[2]}, and ${extra} more`;
}

/**
 * Confirm copy for deleting a list. `templateNames` are the user's templates
 * whose `listIds` include this list (NT-014).
 */
export function listDeleteMessage(templateNames: string[]): string {
  const n = templateNames.length;
  if (n === 0) return "This cannot be undone.";
  const noun = n === 1 ? "template" : "templates";
  return `It's used in ${n} ${noun}: ${joinNames(templateNames)}. Those sections will be skipped when you create a checklist. This cannot be undone.`;
}

/** Owner-only: the section's list is not among the lists this user can see. */
export function isOrphanedListSection(
  isOwner: boolean,
  listId: string,
  knownListIds: ReadonlySet<string>
): boolean {
  return isOwner && !knownListIds.has(listId);
}

/** User-facing text for instantiate/copy warnings, or null when none apply. */
export function describeCreateWarnings(warnings: string[]): string | null {
  const skipped = warnings.filter((warning) => warning.startsWith("SKIPPED_LIST:")).length;
  if (skipped === 0) return null;
  if (skipped === 1) {
    return "1 section was skipped because its list was deleted or is no longer shared with you.";
  }
  return `${skipped} sections were skipped because their lists were deleted or are no longer shared with you.`;
}
